import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Container, TextField, Box, Button } from "@mui/material"
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { fetchNotice } from '../../store/features/notification';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { useAlert } from '../../components/AlertProvider/AlertProvider';

export default function Example() {

  const [img, setImg] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(fetchNotice());
  }, []);

  const minput = useRef(null);
  const showAlert=useAlert();

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const changeHandler = (event) => {
    var file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      // this.setState({
      //   selectedFile: [reader.result]
      // });
      setImg(reader.result);

      console.log(reader.result)
    }

    // this.setState({
    //   mainState: "uploaded",
    //   selectedFile: event.target.files[0],
    //   imageUploaded: 1
    // });
  }
  const clickHandler = () => {
    console.log(minput)
    minput.current.click();
    
  }
  const tijiaoHandler = () => { 
    showAlert(`提交成功`);
  }

  return (
    <Container className='text-mblack' >
      <div className='mt-5 mb-2 ml-2'>意见与建议</div>
      <Box>
        <TextField
          sx={{ width: '100%', marginTop: '1rem', background: 'white', fontSize: '0.5rem' }}
          id="outlined-multiline-static"
          label="请输入您的意见与建议"
          multiline
          rows={6}
          defaultValue=""
        />
      </Box>
      <div className='mt-5 mb-2 ml-2'>上传照片</div>
      <Box sx={{ padding: "2rem", width: '100%', marginTop: '1rem', background: 'white', fontSize: '0.5rem' }}>
        {img ?
          <img src={img} style={{ objectFit: 'cover', width: '100px', height: '100px' }} onClick={clickHandler}></img> :
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            color='mgreen'
            sx={{ width: '20vw', height: '20vw' }}
          >
            <CloudUploadIcon />
            <VisuallyHiddenInput  accept="image/*" type="file" onChange={changeHandler} />
          </Button>
        }
      </Box>
      <Box className='mt-10' >
        <Button onClick={tijiaoHandler} color='mgreen' variant='contained' sx={{ width: '100%' }}>提交</Button>
        <VisuallyHiddenInput  accept="image/*" ref={minput} type="file" onChange={changeHandler} />


      </Box>

    </Container >
  );
}